var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.880837 17.2403C0.748711 17.1182 0.647667 16.9512 0.647667 16.7837C0.647667 16.6325 0.702309 16.4814 0.812813 16.3617L7.85032 8.7026L0.812813 1.04346C0.579659 0.790871 0.594231 0.396837 0.848046 0.16485C1.10064 -0.068306 1.49271 -0.0525284 1.72588 0.199457L9.18694 8.28217C9.40797 8.52138 9.40797 8.88681 9.18694 9.12619L1.72588 17.2089C1.5259 17.4577 1.13342 17.4735 0.880837 17.2403Z","fill":"currentColor"}));
}

ChevronRight.defaultProps = {"width":"10","height":"18","viewBox":"0 0 10 18","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
